import React from "react";
import { InvestorCertificationProvider } from "./AccreditedInvestorGate";
import { IntercomProvider } from "../contexts/IntercomContext";
import { StrategyDraftProvider } from "../contexts/StrategyDraftContext";
import { AlphaAllocationDraftProvider } from "../contexts/AlphaAllocationDraftContext";
import { MultiAccountUiProvider } from "../contexts/MultiAccountUiContext";
import { ProductUpdateNotificationsProvider } from "../contexts/ProductUpdateNotificationsContext";
import { getCapturedAppBootProfile } from "../utils/adminCustomerViewBoot";

export default function AppBootProfileProviderBranch({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement | null {
  const boot = getCapturedAppBootProfile();
  if (boot.status !== "valid") return null;

  if (boot.profile === "customer-view") {
    return <IntercomProvider>{children}</IntercomProvider>;
  }

  return (
    <InvestorCertificationProvider>
      <IntercomProvider>
        <ProductUpdateNotificationsProvider>
          <MultiAccountUiProvider>
            <StrategyDraftProvider>
              <AlphaAllocationDraftProvider>
                {children}
              </AlphaAllocationDraftProvider>
            </StrategyDraftProvider>
          </MultiAccountUiProvider>
        </ProductUpdateNotificationsProvider>
      </IntercomProvider>
    </InvestorCertificationProvider>
  );
}
